import HttpClient from '@/utility/http-client';

export default {
    getList(page: number, rowPerPage: number, filters: any[], quickFilters: any[]) {
        const filter = filters && filters.length > 0 ? Buffer.from(JSON.stringify({ filter: filters })).toString('base64') : '';
        const quickFilter = quickFilters && quickFilters.length > 0 ? Buffer.from(JSON.stringify({ filter: quickFilters })).toString('base64') : '';
        const url = `/api/transition/?filter=${filter}&page=${page}&rowsPerPage=${rowPerPage}&q=${quickFilter}` ;
        return HttpClient.instance().get(url);
    },
    findList(page: number, rowPerPage: number, filters: any[], quickFilters: any[]) {
        const filter = filters && filters.length > 0 ? Buffer.from(JSON.stringify({ filter: filters })).toString('base64') : '';
        const quickFilter = quickFilters && quickFilters.length > 0 ? Buffer.from(JSON.stringify({ filter: quickFilters })).toString('base64') : '';
        const url = `/api/transition/find/?filter=${filter}&page=${page}&rowsPerPage=${rowPerPage}&q=${quickFilter}` ;
        return HttpClient.instance().get(url);
    },
    getSummary() {
        const url = `/api/transition/summary/`;
        return HttpClient.instance().get(url);
    },
    addDetail(dataRequest: any) {
        const url = `/api/order_transactions/`;
        return HttpClient.instance().put(url, dataRequest);
    },
    updateDetail(id: any, dataRequest: any) {
        const url = `/api/order_transaction/${id}`;
        return HttpClient.instance().post(url, dataRequest);
    },
};
